export const mapNodesToObject = <T extends Queries.ContentfulReference>(
  nodes: readonly T[]
): Record<string, T> =>
  nodes.reduce<Record<string, T>>((result, item) => {
    result[item.contentful_id] = item
    return result
  }, {})
